import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from "./../../Header";
import CustomerTabMenu from "./CustomerTabMenu";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import $ from "jquery";
class EnterpriseCustomer extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		this.state = {
			customers: [],
			servers: [],
			serverId: 8,
			server_id: 8,
			account_manager: [],
			apiUrl: this.decryptconfigdata("apiUrl"),
			studioUrl: this.decryptconfigdata("studioUrl"),
			userAuthKey: has_local_data ? localdata.user_key : "",
			loading: 1,
			id: "",
			item_count: "",
		};
		this.serverChange = this.serverChange.bind(this);
		this.customer_details = this.customer_details.bind(this);
		this.onChange = this.onChange.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
	}
	managerChange(propertyName, event) {
		const id = this.state.id;
		id[propertyName] = event.target.value;
		this.setState({ id: id });
	}
	onChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	rawjsonparse(findresponse, flg) {
		return findresponse;
	}
	goToCustomerStore(email, password, studio_id, studio_name) {
		if (window.confirm("Are you sure to login this store '" + studio_name + "' ?")) {
			var win = window.open(
				this.state.site_url +
					"/login/storeLogin" +
					"?email=" +
					email +
					"&password=" +
					password +
					"&studio_id=" +
					studio_id,
				"_blank"
			);
			win.focus();
		}
	}

	serverChange(event) {
		fetch(
			this.state.apiUrl +
				"/adminRest/getEnterpriseStores/userAuthKey/" +
				this.state.userAuthKey +
				"/server_id/" +
				event.target.value,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					customers: findresponse.customers,
					site_url: findresponse.site_url,
					server_id: findresponse.serverid,
					item_count: findresponse.item_count,
					offset: findresponse.offset,
					off_count: findresponse.off_count,
					loading: 0,
				});
			});
	}

	getAllServer() {
		var cur_obj = this;
		fetch(this.state.apiUrl + "/adminRest/getAllServer/userAuthKey/" + this.state.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					serverId: findresponse.default_server_id,
					servers: findresponse.servers,
					loading: 0,
				});
				cur_obj.getServers();
			});
	}

	handlePageChange(pageNumber = 1) {
		var totalPages = Math.ceil(this.state.item_count / 20);
		if (this.state.activePage != pageNumber) {
			$(document).ready(function () {
				$(".pages").addClass("disabled");
			});
			this.setState({ activePage: pageNumber, setPage: "no" });
			fetch(
				this.state.apiUrl +
					"/adminRest/getEnterpriseStores/userAuthKey/" +
					this.state.userAuthKey +
					"/server_id/" +
					this.state.serverId,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					$(document).ready(function () {
						$(".pages").removeClass("disabled");
						if (pageNumber == 1) {
							$(".first_page").addClass("disabled");
							$(".prev_page").addClass("disabled");
						}
						if (pageNumber == totalPages) {
							$(".next_page").addClass("disabled");
							$(".last_page").addClass("disabled");
						}
					});
					this.setState({
						customers: findresponse.customers,
						offset: findresponse.offset,
						off_count: findresponse.off_count,
						setPage: "yes",
					});
				});
		}
	}

	getServers() {
		fetch(
			this.state.apiUrl +
				"/adminRest/getEnterpriseStores/userAuthKey/" +
				this.state.userAuthKey +
				"/server_id/" +
				this.state.serverId,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					customers: findresponse.customers,
					site_url: findresponse.site_url,
					loading: 0,
					item_count: findresponse.item_count,
					offset: findresponse.offset,
					off_count: findresponse.off_count,
					setPage: "yes",
				});
			});
	}
	customer_details(studio_id, studio_name, user_id) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/enterpriseDetails/studio_id/" +
				studio_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					studio_id: findresponse.studio_id,
					id: findresponse.id ? findresponse.id : "",
					account_manager: findresponse.account_manager,
				});
			});
	}
	SaveAccountManager(studio_id) {
		const fd = new FormData();
		var id = document.getElementById("id").value;
		fd.append("account_id", id);
		fd.append("server_id", this.state.server_id);
		fetch(
			this.state.apiUrl +
				"/AdminRest/saveAccountManagerEnterprise/studio_id/" +
				studio_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: fd,
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				window.location.href = "/enterpriseCustomers";
				var obj = this;
				setTimeout(function () {
					obj.getServers();
				}, 100);
			});
	}
	componentDidMount() {
		this.getAllServer();
		//        this.getServers();
		document.title = "Intranet | Enterprise";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}
	}

	getSourceLink(link) {
		if (link) {
			if (link.indexOf("http") !== -1) {
				var linknew = <a href={`${link}`} target="_blank">{`${link}`}</a>;
				return linknew;
			} else {
				return link;
			}
		} else {
			let na = "NA";
			return na;
		}
	}
	export() {
		var win = window.open(
			this.state.apiUrl +
				"/AdminRest/ExportUsers/userAuthKey/" +
				this.state.userAuthKey +
				"/user_type/enterprise/serverid/" +
				this.state.server_id,
			"_self"
		);
		win.focus();
	}
	getStoreName(status, deleted, email, encrypted_password, studio_id, first_name) {
		if (status == 1) {
			return (
				<div onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, first_name)}>
					<a href="javascript:void(0);">Studio Login</a>
				</div>
			);
		} else if (status == 4) {
			return (
				<div
					className="cus_cancel"
					onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, first_name)}
				>
					<a href="javascript:void(0);">
						Studio Login <span class="error">Cancelled</span>
					</a>
				</div>
			);
		} else if (deleted == 1) {
			return <div>Deleted</div>;
		} else {
			return <div></div>;
		}
	}
	getAllEnterPrise() {
		if (this.state.loading) {
			return (
				<div>
					<div class="loader-new"></div>
				</div>
			);
		} else {
			return (
				<section class="customer">
					<div id="exTab1" class="container">
						<CustomerTabMenu brecum_page="enterpriselist" />
						<div class="tab-content clearfix">
							<div class="tab-pane active" id="Deleted">
								<div className="row">
									<div class="col-md-3 col-xs-12 pull-right">
										<div class="filter">
											<select
												id="server"
												class="form-control"
												name="server"
												onChange={this.serverChange}
											>
												{this.state.servers.map((val, key) => (
													<option value={val.id} key={key}>
														{val.customer_name}
													</option>
												))}
											</select>
											<i class="fal fa-angle-down"></i>
										</div>
									</div>
								</div>
								<div class="tickets hidden-sm">
									<ul class="tickets_head">
										<li class="intra_col_15">Company</li>
										<li class="intra_col_12">Name</li>
										<li class="intra_col_10">Website</li>
										<li class="intra_col_10">Country</li>
										<li class="intra_col_10">Joined On</li>
										<li class="intra_col_10">Source</li>
										<li class="intra_col_20">Account Manager</li>
										<li class="intra_col_10">Action</li>
									</ul>
									{this.state.customers.map((data, key) => (
										<ul class="tickets_number">
											<li class="intra_col_15">
												<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
													{" "}
													{data.studio_name}
												</Link>
											</li>
											<li class="intra_col_12">{data.first_name}</li>
											<li class="intra_col_10">
												<a href={"http://" + data.domain} target="_blank">
													{data.domain}
												</a>
											</li>
											<li class="intra_col_10">{data.country}</li>
											<li class="intra_col_10">
												{data.created_dt
													? new Date(data.created_dt).toLocaleDateString("en-US", {
															month: "short",
															day: "numeric",
															year: "numeric",
													  })
													: "N/A"}
											</li>
											<li class="intra_col_10 text-inded">
												{data.source ? this.getSourceLink(data.source) : "N/A"}
											</li>
											<li class="intra_col_20">
												{data.account_manager_name || data.account_manager_name != null ? (
													<a
														href="javascript:void(0);"
														onClick={() =>
															this.customer_details(
																data.studio_id,
																data.first_name,
																data.id,
																this.state.server_id
															)
														}
														data-toggle="modal"
														data-target="#changeaccountmanagername"
													>
														{data.account_manager_name}
													</a>
												) : (
													<a
														href="javascript:void(0);"
														onClick={() =>
															this.customer_details(
																data.studio_id,
																data.first_name,
																data.id,
																this.state.server_id
															)
														}
														data-toggle="modal"
														data-target="#changeaccountmanagername"
													>
														Assign Account Manager
													</a>
												)}
											</li>
											<li class="intra_col_10">
												{this.getStoreName(
													data.status,
													data.is_deleted,
													data.email,
													data.encrypted_password,
													data.studio_id,
													data.first_name,
													data.time_zone_difference
												)}
											</li>
										</ul>
									))}
								</div>
							</div>
						</div>
					</div>
					<div class="customer_mob hidden-md">
						{this.state.customers.map((data, key) => (
							<div class="custmer_list_mob">
								<Link
									key={key}
									to={`/EnterpriseDetails/${data.studio_id}/type/${
										this.state.server_id ? this.state.server_id : this.state.serverId
									}`}
									name={"max"}
								>
									<h4 class="list_title">{data.first_name}</h4>
									<div class="wrap">{data.domain}</div>
								</Link>
								{this.getStoreName(
									data.status,
									data.is_deleted,
									data.email,
									data.encrypted_password,
									data.studio_id,
									data.first_name
								)}
							</div>
						))}
					</div>
					{this.state.item_count > 0 ? (
						<div class="pagination-muvi">
							<Pagination
								itemClass={"pages"}
								itemClassFirst={"first_page"}
								itemClassPrev={"prev_page"}
								itemClassNext={"next_page"}
								itemClassLast={"last_page"}
								activePage={this.state.activePage}
								itemsCountPerPage={20}
								totalItemsCount={this.state.item_count}
								pageRangeDisplayed={5}
								onChange={this.state.setPage == "yes" ? this.handlePageChange : ""}
							/>
							<div style={{ color: "#333" }}>
								{this.state.offset + 1 + " - " + (this.state.offset + this.state.off_count)} of{" "}
								{this.state.item_count}
							</div>
						</div>
					) : (
						<div className="text-center" style={{ color: "#333" }}>
							No Data Found
						</div>
					)}
				</section>
			);
		}
	}

	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}
		return (
			<div>
				{/* <--modal end for change Account Manager Name If Exists-!> */}
				<div class="modal fade" id="changeaccountmanagername" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Set Account Manager
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>Account Manager</b>
								</label>
								<select
									class="form-control"
									id="id"
									name="id"
									value={this.state.id.id}
									onChange={this.state.id.id ? this.managerChange.bind(this, "id") : this.onChange}
								>
									<option value="0">-Select-</option>
									{this.state.account_manager.map((account_manager, key) => (
										<option value={account_manager.id}>{account_manager.name}</option>
									))}
								</select>
								<input type="hidden" value={this.state.studio_id} name="studio_id" />
								{/* ER#75782 key account */}
								<input type="hidden" value={this.state.server_id} name="server_id" />
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-sky" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-blue"
									data-dismiss="modal"
									onClick={() => this.SaveAccountManager(this.state.studio_id)}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				<Header brecum_name="Customer" brecum_page="Enterprise" />
				<div className="right_col">{this.getAllEnterPrise()}</div>
			</div>
		);
	}
}
export default EnterpriseCustomer;



// WEBPACK FOOTER //
// ./src/components/customer/EnterpriseCustomer.js